import React from 'react';
import PageLayout from 'layout/PageLayout/PageLayout';
import CustomBreadCrumb from 'components/CustomBreadCrumb/CustomBreadCrumb';
import { Link } from 'react-router-dom';
import { ROUTES } from 'utils/constants';
import { t } from 'i18next';
import AzureQueue from '../Queue/AzureQueue/AzureQueue';
import PgQueue from '../Queue/PgQueue/PgQueue';
import { Divider } from 'antd';

const Home: React.FC = () => {
  return (
    <div className="diagnostics-main-container px-1">
      <PageLayout
        title={t("diagnosticsHomeLabel") as string}
        loading={false}
        topLeftItem={
          <CustomBreadCrumb
            items={[
              {
                title: (
                  <Link to={ROUTES.DIAGNOSTICS_HOME}>
                    {t("diagnosticsHomeLabel") as string}
                  </Link>
                ),
              },
            ]}
          />
        }
      >
          <AzureQueue />
          <Divider/>
          <PgQueue />    
      </PageLayout>   
    </div>
  );
};

export default Home;
